export function localCalendarDayAsUTCMidnight(date: Date): Date {
    return new Date(
        Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
    );
}

export function utcCalendarDayAsLocalMidnight(date: Date): Date {
    return new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
    );
}
